<!-- 常用分类 -->
<template>
  <div class="Category">
    <div class="alert-style" v-if="number>0">
      <el-alert type="info" :closable="false">
        <slot>已选择<span style="color:#409EFF;padding: 0 5px;">{{number}}</span>项一级常用分类</slot>
      </el-alert>
    </div>
    <div class="table-style">
      <el-table :data="commonData" ref="multipleTable" @select="handleSelectionChange"
        :header-cell-class-name="cellClass"
        style="width: 100%;margin-top:20px">
        <el-table-column type="expand">
          <template slot-scope="props">
            <div class="expand-box">
              <ul>
                <li class="title"><span>二级分类名称</span> <span>创建时间</span></li>
                <li v-for="sndCol in props.row.childeren" :key="sndCol.id">
                <span>{{sndCol.categoryName}}</span>
                <span> {{sndCol.createTime|timeFormat}}</span>
              </li>
              </ul>
            </div>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip v-for="col in commonCols" :key="col.id" :prop="col.prop" :align="'center'"
          :label="col.label"
          :width="col.width">
        </el-table-column>
        <el-table-column label="创建时间" :align="'center'"><template slot-scope="scope"> {{scope.row.createTime|timeFormat}} </template></el-table-column>
        <el-table-column  label="选为常用分类" width="200px;" label-class-name="DisabledSelection" :align="'center'"
          type="selection">
        </el-table-column>
      </el-table>
    </div>
    <Page :total="commonPaging.total" @pageChange="commonPageChange"/>
  </div>
</template>
<script>
import Page from '@/components/pagination'
import { fetchCommonCategory, fetchCheckCategory } from '@/resource/api/index'
export default {
  name: 'Category',
  components: {
    Page
  },
  data () {
    return {
      commonCols: [ // 常用分类 table col
        { prop: 'categoryName', label: '一级分类名称' },
        { prop: 'sndCount', label: '二级分类数量' }
      ],
      commonPaging: { // 常用分类 分页参数
        total: 0,
        index: 1,
        size: 20
      },
      commonData: [], // 常用分类TABLE DATA
      multipleSelection: [],
      number: 0 // 多选数量长度
    }
  },
  mounted () {
    this.$refs.multipleTable.clearSelection()
    this.fetchCommon()
  },
  methods: {
    cellClass (row) {
      if (row.columnIndex === 4) {
        return 'disabledCheck'
      }
    },
    // 常用分类分页
    commonPageChange (item) {
      this.commonPaging.index = item.currentPage
      this.commonPaging.size = item.pageSize
      this.fetchCommon()
    },
    // 常用分类 DATA
    fetchCommon () {
      const data = {
        createBy: this.$store.state.router.createBySuffix,
        dataFlag: '0',
        limit: this.commonPaging.size,
        offset: this.commonPaging.index
      }
      fetchCommonCategory(data).then((res) => {
        if (res.code == '1') {
          this.commonData = res.results
          this.commonPaging.total = parseInt(res.total)
          this.toggleSelection(this.commonData)
        }
      })
    },
    // 切换某一行的选中状态
    toggleSelection (rows) {
      var that = this
      this.number = 0
      rows.forEach(row => {
        if (row.inUse == 0) {
          this.number++
          that.$nextTick(() => {
            that.$refs.multipleTable.toggleRowSelection(row, true)
          })
        }
      })
    },
    handleSelectionChange (val, rows) {
      this.multipleSelection = val
      this.number = this.multipleSelection.length
      rows.createBy = this.$store.state.router.createBySuffix
      rows.inUse = rows.inUse == 0 ? 1 : 0
      const data = rows
      fetchCheckCategory(data).then((res) => {
        if (res.code == '1') {
          this.fetchCommon()
        }
      })
    }
  }
}
</script>
<style lang="less">
.el-table .disabledCheck .cell .el-checkbox__inner{
  display: none !important;
}
.el-table .disabledCheck .cell::before{
  content: '选为常用分类';
  text-align: center;
  line-height: 37px;
}
.table-style .el-table .cell .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #13C83D;
    border-color: #13C83D;
}
</style>
<style lang="less" scoped>
.expand-box {
  width: 450px;
  height: 165px;
  overflow-y: scroll;
  margin: 0 auto;
  box-shadow: 0px 4px 16px 0px rgba(41, 50, 69, 0.1);
  border-radius: 4px;
  background: #fff;
  .title {
    color: #A0A0A2;
  }
  li {
    display: flex;
    justify-content: space-around;
    text-align: left;
    padding:10px;

    span:nth-child(1) {
      width: 60%;
      padding-left:20px;
    }
    span:nth-child(2) {
      width: 40%;
    }

  }
}

</style>
